import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPlan, setPlan } from '../paywallSlice';
import { selectOfferType } from '../../onboarding/onboardingSlice';
import AppButton from './components/AppButton';
import PlansDescription from './PlansDescription';
import { OfferDescription, OfferTitle, UnlockTitle, UnlockWrapper } from './styles/freeTrialStyles';

export const FreeTrialGzPlans = ({onBuyClick}) => {
    const dispatch = useDispatch();
    const plan = useSelector(selectPlan);
    const landingType = useSelector(selectOfferType);
    const freeTrialPlans = useMemo(
        () => [
            {
                id: 'gz-1-month-free3d-2999',
                title: '3 days free',
                description: 'Then $29.99 per month',
            },
        ],
        []
    );
    const FREETRIAL_PLANS = useMemo(
        () => ({
            gz_freetrial: freeTrialPlans,
            'gz_freetrial-anim': freeTrialPlans,
            'gz_freetrial-monthly': [
                {
                    id: 'gz-1-month-free3d-1499',
                    title: '3 days free',
                    description: 'Then <strike>$29.99</strike> $14.99/month',
                },
            ],
            'gz_freetrial-weekly': [
                {
                    id: 'gz-1-month-free3d-1996',
                    title: '3 days free',
                    description: 'Then $4.99/week*',
                },
            ],
            'gz_month-trial': [
                {
                    id: 'gz-1-month-intro1m-999-2999',
                    title: '1 month trial',
                    description: 'at $9.99 then $7.49/week*',
                },
            ],
        }),
        [freeTrialPlans]
    );


    const currentPlans = useMemo(
        () => FREETRIAL_PLANS[landingType],
        [landingType, FREETRIAL_PLANS]
    );
    useEffect(() => {
        dispatch(setPlan(currentPlans[0].id));
    }, [dispatch, currentPlans]);

    const planHints = useMemo(
        () => ({
            'gz-1-month-free3d-2999': null,
            'gz-1-month-free3d-1499': null,
            'gz-1-month-free3d-1996': '*3-day free trial, then for $19.96/ month',
            'gz-1-month-intro1m-999-2999': '*1-month $9.99 trial, then for $29.99/ month',
        }),
        [landingType]
    );

    const renderOffer = (i) => (
        <UnlockWrapper key={i}>
            <OfferTitle>{i.title}</OfferTitle>
            <OfferDescription dangerouslySetInnerHTML={{ __html: i.description }} />
        </UnlockWrapper>
    );

    const continueButton = (displayStickyBtn, sticky) => (
        <AppButton
            onClick={onBuyClick}
            bottomPosition={'24px'}
            displayStickyBtn={displayStickyBtn}
            position={sticky}
            customStickyWidth={'100%'}
            customBeforeHeight={'0px'}
            displayStubBtn={false}
        >
        Continue
        </AppButton>
    );

    return (
        <>
            <UnlockTitle>Unlock all features</UnlockTitle>
            {currentPlans.map(renderOffer)}
            <PlansDescription
                continueButton={continueButton}
                btnAfter
                showHint={planHints[plan]}
            />
        </>
    );
};

export default FreeTrialGzPlans;
